import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";

import { gql } from "@examspark/api";
import {
  AnalyticsEventName,
  useAnalytics,
  useAppContext,
} from "@examspark/common-app";
import { Button, Modal, ModalProps, Text, VSpace } from "@examspark/common-ui";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";

const StyledH1 = styled.h2`
  font-size: 2.5em;
  font-weight: 500;
  color: #333;
`;

const StyledBody = styled(Text.Body)`
  line-height: 1.7em;
  color: #555;
`;

const StyledPadding = styled(PaddedBody)`
  padding: 1.5rem;
`;

const RedirectToCampfireModal = (props: ModalProps) => {
  const [context] = useAppContext();
  const appId = "29ff753b-0fae-49c3-891a-e10d9873abfb";
  const analytics = useAnalytics();
  const [url, setUrl] = useState<string>();

  const fetchLoginToken = useCallback(async () => {
    if (!context.user?.id) return;
    if (!context.appLicense?.appKey) return;

    const login = await gql.operations.user.getLoginTokenForAppUser({
      appId: appId,
      userId: context.user.id,
      appKey: context.appLicense.appKey,
      workspaceId: context.workspace?.id,
    });

    if (login == null || login.error != null) {
      console.error("Could not login as user", context.user.id);
      alert(login?.error ?? "Could not login as user");
      return;
    }

    setUrl(login.url);
  }, [context.appLicense?.appKey, context.user?.id, context.workspace?.id]);

  useEffect(() => {
    if (!props.isOpen) return;
    fetchLoginToken();
  }, [props.isOpen, fetchLoginToken]);

  return (
    <Modal
      title=""
      size="medium"
      {...props}
      onAfterClose={() => setUrl(undefined)}
      buttons={
        <>
          <Button title="Cancel" onClick={props.onRequestClose}>
            Cancel
          </Button>
          <Button
            isLoading={!url}
            disabled={!url}
            title="Proceed"
            color="primary"
            onClick={() => {
              props.onRequestClose?.();
              const _url = url?.replace("3010", "3014");
              analytics.trackEvent(AnalyticsEventName.LaunchProxyApp);
              window.open(_url, "_blank");
            }}
          >
            Proceed
          </Button>
        </>
      }
    >
      <StyledPadding>
        <div>
          <VSpace size="1.5rem">
            <StyledH1>
              We are redirecting you to Campfire Learning for Assessments
            </StyledH1>
            <StyledBody>
              Online assessment delivery for Go TCMPC is powered separately by
              Campfire Learning. Click Proceed to open a new tab for Campfire
              Assessments.
            </StyledBody>
          </VSpace>
        </div>
      </StyledPadding>
    </Modal>
  );
};

export default RedirectToCampfireModal;
